/* eslint @typescript-eslint/no-unsafe-member-access: 0 */
/* eslint @typescript-eslint/no-unsafe-call: 0 */
import React from 'react'
import { render } from 'react-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { Provider } from 'react-redux'
import { App } from 'app/App'
import { queryClient } from 'app/queryClient'
import { store } from 'app/store'
import { serviceWorker } from 'helpers/serviceWorker'
import { createRoot } from 'react-dom/client'
import { applyDomMutationRecoveryGuard, installDomMutationDiagnostics } from 'helpers/domMutationRecovery'

installDomMutationDiagnostics()
applyDomMutationRecoveryGuard()

// Needed for Hot Module Replacement
if (typeof (module.hot) !== 'undefined') { // eslint-disable-line no-undef
    module.hot.accept() // eslint-disable-line no-undef
}

const container = document.getElementById('app')
const root = createRoot(container)
root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <App />
            </Provider>
        </QueryClientProvider>
    </React.StrictMode>,
)

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
